import { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import { ApiHelper } from "../utils/ApiHelper";
import { COMPANY_DETAIL } from "../lib/API_KEYS";

export default function ProfileModal({
    show,
    companyId,
    onClose,
}) {
    const [formData, setFormData] = useState(null);

    useEffect(() => {
        if (show) {
            document.body.style.overflow = "hidden";
        }
        return () => (document.body.style.overflow = "auto");
    }, [show]);

    useEffect(() => {
        if (!companyId) return;
        const fetchData = async () => {
            try {
                const res = await new ApiHelper().FetchFromServer(
                    COMPANY_DETAIL[0].replace(":companyId", companyId),
                    COMPANY_DETAIL[1],
                );
                if (res.data) {
                    setFormData(res.data);
                }
            } catch (err) {
                console.error("Fetch error:", err);
                // toast.error("Failed to fetch form data");
            }
        };
        fetchData();
    }, [companyId]);

    if (!show || !formData) return null;

    return (
        <div
            className="modal fade show d-block "
            tabIndex="-1"
            style={{
                background: "rgba(0,0,0,0.5)",
                backdropFilter: "blur(4px)",
                zIndex: 1200,
            }}
            onClick={onClose}
        >
            <div
                className="modal-dialog modal-dialog-centered modal-dialog-scrollable"

                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content p-0 rounded-4 border-0">
                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
                        <h5 className="fw-bold mb-0">Company Profile</h5>
                        <button className="btn-close" onClick={onClose} />
                    </div>

                    {/* Body */}
                    <div className="modal-body p-4">
                        <div className="container-fluid profile-page">
                            {/* Profile Header */}
                            <div className="text-center mb-4">
                                <img
                                    src={formData?.logo || "/favicon.ico"}
                                    alt="Profile"
                                    className="profile-avatar mb-2"
                                />
                                <h4 className="fw-bold">{formData?.name}</h4>

                                <div className="rating mb-2">
                                    {Array(5)
                                        .fill(0)
                                        .map((_, i) => (
                                            <FaStar key={i} color="#f5c518" />
                                        ))}
                                </div>

                                <p className="text-muted d-flex flex-wrap justify-content-center gap-3">
                                    <span className="d-flex align-items-center gap-1">
                                        <img src="/images/company.svg" width="18" />
                                        {formData?.linkedIn}
                                    </span>
                                    <span className="d-flex align-items-center gap-1">
                                        <img src="/images/location.svg" width="18" />
                                        {formData?.address}
                                    </span>
                                </p>
                            </div>

                            {/* Stats */}
                            {/* <div className="row text-center border py-3 rounded-4 shadow-sm mb-4">
                <div className="col-6 col-md-3 border-end">
                  <h5 className="fw-bold">
                    {Object.values(requirementsCount).reduce((s, n) => s + n, 0) ||
                      0}
                  </h5>
                  <p className="text-muted">Total RFQ</p>
                </div>
                <div className="col-6 col-md-3 border-end">
                  <h5 className="fw-bold">
                    {requirementsCount?.["In Review"] || 0}
                  </h5>
                  <p className="text-muted">In Review</p>
                </div>
                <div className="col-6 col-md-3 border-end">
                  <h5 className="fw-bold">
                    {requirementsCount?.Approved || 0}
                  </h5>
                  <p className="text-muted">Approved</p>
                </div>
                <div className="col-6 col-md-3">
                  <h5 className="fw-bold">
                    {requirementsCount?.Rejected || 0}
                  </h5>
                  <p className="text-muted">Rejected</p>
                </div>
              </div> */}

                            {/* Details */}
                            <div className="row">
                                {/* <div className="col-md-6"> */}
                                <Card className="mb-3 shadow-sm border-0 rounded-4">
                                    <Card.Body>
                                        <h6 className="fw-bold mb-2">Profile</h6>
                                        <hr />

                                        <p className="d-flex align-items-center gap-2">
                                            <img src="/images/mail.svg" width="20" />
                                            {formData?.email}
                                        </p>

                                        <p className="d-flex align-items-center gap-2">
                                            <img src="/images/web.svg" width="20" />
                                            {formData?.website}
                                        </p>
                                    </Card.Body>
                                </Card>
                            </div>

                            <div className="row">

                                {/* <div className="col-md-6"> */}
                                <Card className="mb-3 shadow-sm border-0 rounded-4">
                                    <Card.Body>
                                        <h6 className="fw-bold mb-2">About</h6>
                                        <hr />
                                        <p className="text-muted">
                                            {formData?.aboutUs ||
                                                "Results-driven seller with a strong focus on quality and long-term partnerships."}
                                        </p>
                                    </Card.Body>
                                </Card>
                            </div>
                            {/* </div> */}
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="px-4 py-3 border-top d-flex justify-content-end">
                        <button className="btn btn-outline-dark px-4" onClick={onClose}>
                            Close
                        </button>
                    </div>
                </div>
            </div>

            {/* Styles */}
            <style>{`
        .profile-avatar {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          border: 4px solid #17C653;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }
        .border-end {
          border-right: 1px solid #dee2e6;
        }
      `}</style>
        </div >
    );
}
